<dcs-text-field
  invalid
  helpertext="{{ helpertext }}"
  label="{{ label }}"
  name="{{ name }}"
  placeholder="{{ placeholder }}"
  required="{{ required }}"
  invalidtext="{{ invalidtext }}"
  [formControl]="formControl"
  [formlyAttributes]="field"
  disabled = "{{ disabled }}"
></dcs-text-field>
